import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import Zocdoc from "./Zocdoc";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Zocdoc />
    <App />
  </React.StrictMode>
);
